import InsuranceCard from './InsuranceCard'

export default InsuranceCard
